<template>
  <div class="service-form">
    <div class="service-form-nav">
      <z-icon
        class-prefix="zziconfont"
        name="warning-text"
        :style="{
          display: 'inline-block',
          color: 'red', marginRight:
          '10px'
        }"
      />
      <span>修改地址可能会导致运输时效增加且会增加转运费用，有疑问可返回上级联系人工客服。</span>
    </div>
    <div class="service-form-area">
      <z-cell-group>
        <z-field v-model="formData.orderId" label="订单ID" readonly />
        <z-field v-model="formData.receiverName" label="收件人姓名" placeholder="请输入收件人姓名" />
        <z-field
          use-number-keyboard
          v-model="formData.receiverPhone"
          label="收件人电话"
          @focus="onPhoneFocus"
          @blur="onPhoneBlur"
          placeholder="请输入收件人电话"
        />
      </z-cell-group>
    </div>
    <div class="service-form-area">
      <p>
        <label>收件人地址</label>
      </p>
      <z-cell-group>
        <div class="service-form-input-wrap" @click="handlePopArea">
          <z-field v-model="formData.receiverAdress" placeholder="点击选择地址" label="省市县" readonly />
        </div>
        <z-field v-model="formData.receiverAdressDetail" label="详细地址" placeholder="请输入收件人详细地址" />
      </z-cell-group>
    </div>
    <z-popup v-model="showArea" position="bottom">
      <z-area @confirm="onAreaConfirm"/>
    </z-popup>
    <z-number-keyboard
      :show="numberKeyboardShow"
      @input="onKeyboardInput"
      @delete="onKeyboardDelete"
    />
    <z-button-group>
      <z-button @click="confirmSubmit" type="primary">提交</z-button>
    </z-button-group>
  </div>
</template>

<script>
import {
  Icon,
  Field,
  CellGroup,
  Popup,
  Area,
  Button,
  ButtonGroup,
  Toast,
  NumberKeyboard
} from '@zz-common/zz-ui';
import native from '@zz-common/native-adapter'
import { zljModifyAddress } from '../../api/resourceApi'
import { hideShareButton, closeZljRefresh, queryParams } from '../../lib/utils'

const query = queryParams()

export default {
  name: 'serviceForm',
  components: {
    'z-icon': Icon,
    'z-cell-group': CellGroup,
    'z-field': Field,
    'z-popup': Popup,
    'z-area': Area,
    'z-button-group': ButtonGroup,
    'z-button': Button,
    'z-number-keyboard': NumberKeyboard
  },
  data() {
    return {
      showArea: false, // 地址控件
      numberKeyboardShow: false, // 数字软键盘
      formData: {
        orderId: query.orderId || this.$route.query.orderId, // 订单id
        receiverName: '', // 收件人姓名
        receiverPhone: '', // 收件人电话
        receiverAdress: '', // 收件人地址
        receiverAdressDetail: '' // 收件人详细地址
      }
    }
  },
  created() {
    hideShareButton()
    closeZljRefresh()
    native.setTitle({
      title: '自助提交'
    })
  },
  mounted() {
  },
  methods: {
    validateSubmit() {
      let isAllFinish = true
      for (const key in this.formData) {
        if (this.formData[key] === '' || !this.formData[key]) {
          isAllFinish = false
          Toast('请填写完表单项')
          break
        }
      }
      return isAllFinish
    },
    handlePopArea() {
      this.showArea = true
    },
    onAreaConfirm(data) {
      this.showArea = false
      const result = data.reduce((dist, cur) => {
        if (!cur) return dist
        return dist + ' ' + cur.name
      }, '')
      this.formData.receiverAdress = result
    },
    async confirmSubmit() {
      const isFinish = this.validateSubmit()
      if (!isFinish) return
      const res = await zljModifyAddress(this.formData)
      const { isSuccess } = res
      if (isSuccess) {
        this.$router.push({
          name: +isSuccess === 1 ? 'serviceFormSuccess' : 'serviceFormFail'
        })
      } else {
        Toast('网络异常，请稍后再试')
      }
    },
    onPhoneFocus() { this.numberKeyboardShow = true },
    onPhoneBlur() { this.numberKeyboardShow = false },
    onKeyboardInput(value) { this.formData.receiverPhone += value },
    onKeyboardDelete(_value) {
      this.formData.receiverPhone = this.formData.receiverPhone.slice(0, -1)
    }
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
